import { HUMAN_ACCOUNT_TYPES } from '@omniwound/auth-contract';

/**
 * The one place the clinician app decides which Human Account Type an account
 * holds. `ApplicationAccessGate` (admission), the provider-capabilities gate and
 * the navigation derivation must agree; a second copy of this expression is how
 * they drift.
 *
 * "Exactly one" is the rule, not an accident: a principal carrying two Human
 * Account Types is not a Provider and not a Staff account, and the gates that
 * consume these predicates treat such an account the way they treat an unknown
 * one (they do not claim the workspace belongs to it).
 */
export function isStaffAccount(humanAccountTypes: readonly string[]): boolean {
  return (
    humanAccountTypes.length === 1 &&
    humanAccountTypes[0] === HUMAN_ACCOUNT_TYPES.STAFF
  );
}

export function isProviderAccount(
  humanAccountTypes: readonly string[],
): boolean {
  return (
    humanAccountTypes.length === 1 &&
    humanAccountTypes[0] === HUMAN_ACCOUNT_TYPES.PROVIDER
  );
}
